module.exports = __webpack_public_path__ + "img/20190906154701371.9f5e54e7.jpg";